import React from "react";
import styled from "styled-components";
import Spinner from "../../../components/spinner";
import LibraryHero from "./library-hero";
import BookSwimlane from "../bookviews/book-swimlane";
import OnboardingBook from "../../../components/swimlane/OnboardingBook";
import BookGrid from "../bookviews/book-grid";
import GridView from "../bookviews/gridview";
import { withAllMatches } from "../../../components/mediaquery/breakpoints";
import { connect } from "react-redux";
import {
  actions as feenyActions,
  selectors as feenySelectors
} from "../../../../redux/feeny";
import {
  selectors as booksSelectors,
  actions as booksActions
} from "../../../../redux/books";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as ancillariesActions } from "../../../../redux/ancillaries";
import { actions as bridgeActions } from "../../../../redux/bridge";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { selectors as licenseSelectors } from "../../../../redux/license";
import { t } from "../../../core/translate";
import Banner from "../banner";
import LibraryNullScreen from "../library-null-screen";
import PageTitle from "../../../utils/page-title";
import LibraryHelpers from "../../../../stores/library-helpers";
import ActionBlocks from "../action-blocks";
import ExpiredBooksLane from "./expired-books-lane";
import PromotionGrid from "../promotions-lane/promotion-grid";
import PromotionSwimlane from "../promotions-lane";
import ExpiredBooksGrid from "./expired-books-grid";
import { studentBannerPadding } from "../../../components/mixins";

const Frame = styled.div`
  ${props =>
    studentBannerPadding(props.showStudentBanner, props.isSmall, props.native)};
`;

const MainContentArea = styled.div`
  flex-grow: 2;
  overflow: auto;
  height: 100vh;
`;

const ExpandedSwimlane = {
  NONE: "none",
  MY_BOOKS: "my-books",
  PROMOTIONS: "promotions",
  EXPIRED_BOOKS: "expired-books"
};

class LibraryTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedSwimlane: ExpandedSwimlane.NONE
    };
  }

  componentDidMount() {
    if (!this.props.licenseUpdating) {
      this.props.loadBookList();
      this.props.loadExpiredBooks();
      this.props.fetchAncillarySummary();
      this.props.fetchAllAccessCodes();
      this.props.dispatch({ type: "LIBRARY_TAB_REMOUNTED_ON_MOUNT" });
      if (this.props.hasTotalUserCredits) {
        this.props.loadBridgeBooks(true);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.licenseUpdating !== this.props.licenseUpdating &&
      !this.props.licenseUpdating
    ) {
      this.props.loadBookList(true);
      this.props.fetchAncillarySummary(true);
      this.props.fetchAllAccessCodes(true);
      this.props.dispatch({
        type: "LIBRARY_TAB_REMOUNTED_ON_UPDATE"
      });
      if (this.props.hasTotalUserCredits) {
        this.props.loadBridgeBooks(true);
      }
    }
    LibraryHelpers.updateBookToast(this.props.book);
    LibraryHelpers.supportedBrowserToast();
  }

  getMyBooksHeaderText = () => {
    return t("filter.my-books", "My Books");
  };

  expandMyBooks = () => {
    this.setState({
      expandedSwimlane: ExpandedSwimlane.MY_BOOKS
    });
  };

  expandPromotions = () => {
    this.setState({
      expandedSwimlane: ExpandedSwimlane.PROMOTIONS
    });
  };

  expandExpiredBooks = () => {
    this.setState({
      expandedSwimlane: ExpandedSwimlane.EXPIRED_BOOKS
    });
  };

  collapseView = () => {
    this.setState({
      expandedSwimlane: ExpandedSwimlane.NONE
    });
  };

  renderAllBooksSwimlane() {
    const { isbns, totalBooks, shouldShowOnboarding } = this.props;

    const titleCards = [];
    if (shouldShowOnboarding) {
      titleCards.push({
        index: 1,
        content: <OnboardingBook />
      });
    }

    return (
      <BookSwimlane
        isbns={isbns.slice(1, 101)}
        headerLabel={this.getMyBooksHeaderText()}
        onHeaderClick={this.expandMyBooks}
        titleCards={titleCards}
        count={totalBooks}
      />
    );
  }

  render() {
    const {
      isbns,
      licenseUpdating,
      asyncLicenseUpdate,
      totalBooks,
      isLoadingBooks,
      isSmall,
      redirectToExplore,
      bridgeUserFetching,
      hasShortcuts,
      enableStudentBanner,
      native
    } = this.props;

    const { expandedSwimlane } = this.state;

    if (
      (licenseUpdating && (!asyncLicenseUpdate || totalBooks === 0)) ||
      (totalBooks === 0 && isLoadingBooks) ||
      (redirectToExplore && bridgeUserFetching)
    ) {
      return (
        <MainContentArea>
          <PageTitle
            title={t("library.license-updating2", "License Updating")}
          />
          <Spinner />
        </MainContentArea>
      );
    } else if (totalBooks === 0) {
      return <LibraryNullScreen />;
    }

    if (expandedSwimlane === ExpandedSwimlane.EXPIRED_BOOKS) {
      return <ExpiredBooksGrid onHeaderClick={this.collapseView} />;
    } else if (expandedSwimlane === ExpandedSwimlane.PROMOTIONS) {
      return <PromotionGrid onHeaderClick={this.collapseView} />;
    } else if (expandedSwimlane === ExpandedSwimlane.MY_BOOKS) {
      if (isSmall) {
        return (
          <div>
            <PageTitle title={t("main-menu.library", "Library")} />
            <BookGrid
              onHeaderClick={this.collapseView}
              isbns={isbns.map(isbn => ({ isbn }))}
              headerLabel={this.getMyBooksHeaderText()}
              count={isbns.length}
            />
          </div>
        );
      }
      return (
        <div>
          <PageTitle title={t("main-menu.library", "Library")} />
          <GridView
            onHeaderClick={this.collapseView}
            isbns={isbns}
            headerLabel={this.getMyBooksHeaderText()}
            count={isbns.length}
            showCollections
            showPillButtons
          />
        </div>
      );
    } else {
      return (
        <Frame
          showStudentBanner={enableStudentBanner}
          isSmall={isSmall}
          native={native}
        >
          <PageTitle title={t("main-menu.library", "Library")} />
          <LibraryHero isbn={isbns[0]} key={isbns[0]} />
          {isbns.length > 1 && this.renderAllBooksSwimlane()}
          <ExpiredBooksLane onHeaderClick={this.expandExpiredBooks} />
          <PromotionSwimlane onHeaderClick={this.expandPromotions} />
          {!hasShortcuts && totalBooks === 1 && <ActionBlocks />}
          <Banner />
        </Frame>
      );
    }
  }
}

const mapStateToProps = state => {
  const isbns = booksSelectors.getIsbns(state);
  const totalBooks = booksSelectors.getTotalBooks(state);
  const licenseUpdating = licenseSelectors.isLicenseUpdating(state);
  const asyncLicenseUpdate = brandSelectors.getBrandValue(
    state,
    "Library.asyncLicense",
    false
  );
  const redirectToExplore = brandSelectors.getBrandValue(
    state,
    "Library.redirectToExplore",
    false
  );
  const isLoadingBooks = booksSelectors.isLoading(state);
  const shouldShowOnboarding = brandSelectors.shouldShowOnboarding(state);
  const book = booksSelectors.getBooksByIsbn(state, isbns);
  const hasTotalUserCredits = bridgeSelectors.hasTotalUserCredits(state);
  const enableStudentBanner = brandSelectors.getBrandValue(
    state,
    "StudentHome.enabled"
  );
  return {
    isbns,
    totalBooks,
    licenseUpdating,
    asyncLicenseUpdate,
    redirectToExplore,
    isLoadingBooks,
    shouldShowOnboarding,
    book,
    hasTotalUserCredits,
    bridgeUserFetching: bridgeSelectors.isUserFetching(state),
    hasShortcuts: bridgeSelectors.getPromotions(state).length,
    enableStudentBanner
  };
};

const mapDispatchToProps = dispatch => ({
  loadBookList: force => dispatch(booksActions.loadBookList({}, force)),
  loadExpiredBooks: () => dispatch(booksActions.loadExpiredBooks()),
  loadBridgeBooks: force => {
    dispatch(
      bridgeActions.fetchLists(
        [
          {
            sort: "recent",
            active: true
          }
        ],
        force
      )
    );
  },
  fetchAncillarySummary: force =>
    dispatch(ancillariesActions.fetchAncillarySummary(force)),
  fetchAllAccessCodes: force =>
    dispatch(ancillariesActions.fetchAllAccessCodes(force)),
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAllMatches(LibraryTab));
